import React from "react";

const Projecthydgeo = () => {
  return (
    <div>
      <p>Details </p>
    </div>
  );
};

export default Projecthydgeo;
